module.exports = __webpack_public_path__ + "img/userFemale.56455554.jpg";